"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvcBillingAutomationWebClient = void 0;
const http_1 = __importDefault(require("http"));
const https_1 = __importDefault(require("https"));
const axios_1 = __importDefault(require("axios"));
const axios_retry_1 = __importDefault(require("axios-retry"));
class SvcBillingAutomationWebClient {
    constructor(url, configClient) {
        var _a, _b;
        const agentOptions = {
            keepAlive: true,
            keepAliveMsecs: 1000,
            maxFreeSockets: 20,
            maxSockets: 100,
        };
        const config = {
            baseURL: url,
            headers: {
                common: { Accept: 'application/json', 'X-Source-Client': configClient.clientSource },
                delete: {},
                get: {},
                head: {},
                patch: { 'Content-Type': 'application/json' },
                post: { 'Content-Type': 'application/json' },
                put: { 'Content-Type': 'application/json' },
            },
            httpAgent: (configClient === null || configClient === void 0 ? void 0 : configClient.keepAlive) ? new http_1.default.Agent(agentOptions) : undefined,
            httpsAgent: (configClient === null || configClient === void 0 ? void 0 : configClient.keepAlive) ? new https_1.default.Agent(agentOptions) : undefined,
            timeout: (_a = configClient === null || configClient === void 0 ? void 0 : configClient.timeout) !== null && _a !== void 0 ? _a : 5000,
        };
        this.clientWithoutRetry = axios_1.default.create(config);
        this.clientWithRetry = axios_1.default.create(config);
        (0, axios_retry_1.default)(this.clientWithRetry, {
            retries: (_b = configClient === null || configClient === void 0 ? void 0 : configClient.retries) !== null && _b !== void 0 ? _b : 5,
            retryCondition: axios_retry_1.default.isRetryableError,
            retryDelay: axios_retry_1.default.exponentialDelay,
            shouldResetTimeout: true,
        });
    }
}
exports.SvcBillingAutomationWebClient = SvcBillingAutomationWebClient;
//# sourceMappingURL=SvcBillingAutomationWebClient.js.map